module.exports = __webpack_public_path__ + "img/1797.21c680d5.png";